import React, { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RolesNames } from '../../models/employee';
import { Project as ProjectModel } from '../../models/project';
import { deleteProject } from '../../services/api/projectService';
import { AppCard } from '../app/appCard';
import { AppConfirmationDelete } from '../app/confirmation/appConfiramationDelete';
import { AppConfirmationSuccessful } from '../app/confirmation/appConfirmationSuccessful';
import { Typography } from '@mui/material';
import { ColorPalette } from '../../styles/constants';
import { useUserRoles } from '../../hooks/useUserRoles';
import { useSelector } from 'react-redux';
import { selectProfileId } from '../../store/profileSlice';
import { generateProjectLabel } from '../../services/projectService';

interface Props {
  project: ProjectModel;
  onRequestSuccessful?(): void;
  handleEditProject(project: ProjectModel): void;
}

export function Project({
  project,
  // onRequestSuccessful,
  handleEditProject,
}: Props): JSX.Element {
  // COMMENTED THE DELETE PROJECT FUNCTIONALITY AS PER REQUEST - might be needed later
  // const [isOpenDeleteDialog, setIsOpenDeleteDialog] = useState<boolean>(false);
  const [isOpenConfirmationDialog, setIsOpenConfirmationDialog] =
    useState<boolean>(false);

  const navigate = useNavigate();
  const { isAdmin } = useUserRoles();
  const profileId = useSelector(selectProfileId);

  const canEditProject = useMemo(
    () =>
      isAdmin ||
      project.projectOwnerId === profileId ||
      project.salesManagerId === profileId,
    [isAdmin, profileId, project.projectOwnerId, project.salesManagerId]
  );

  // const handleDelete = useCallback(() => {
  //   setIsOpenDeleteDialog(true);
  // }, []);

  // const handleCloseDeleteDialog = useCallback(() => {
  //   setIsOpenDeleteDialog(false);
  // }, []);

  // const handleConfirmDeleteProject = useCallback(() => {
  //   deleteProject(project.id)
  //     .then(() => {
  //       handleCloseDeleteDialog();
  //       setIsOpenConfirmationDialog(true);
  //     })

  //     .then(() => {
  //       setTimeout(() => {
  //         handleCloseDeleteDialog();
  //         onRequestSuccessful();
  //       }, 500);
  //     });
  // }, [project, onRequestSuccessful, handleCloseDeleteDialog]);

  const handleCloseConfirmationDialog = useCallback(() => {
    setIsOpenConfirmationDialog(false);
  }, []);

  const handleEdit = useCallback(() => {
    handleEditProject(project);
  }, [handleEditProject, project]);

  const handleTasks = useCallback(() => {
    if (project)
      navigate(`/projects/${project.id}/tasks`, { state: { project } });
  }, [navigate, project]);

  const generateProjectDetails = useCallback((label: string, value: string) => {
    return (
      <Typography
        component={'span'}
        sx={{ color: ColorPalette.DARK_GRAY, fontWeight: 400 }}
      >
        {label}:{' '}
        <Typography
          component={'span'}
          sx={{ color: ColorPalette.RAISIN_BLACK }}
        >
          {value}
        </Typography>
      </Typography>
    );
  }, []);

  const cardActionButtons = useMemo(
    () =>
      [
        // {
        //   label: 'Delete',
        //   onClick: handleDelete,
        //   isPrimary: false,
        // },
        {
          label: 'Tasks',
          onClick: handleTasks,
          isPrimary: false,
          isVisible: true,
        },
        {
          label: 'Edit',
          onClick: handleEdit,
          isPrimary: true,
          isVisible: canEditProject,
        },
      ]
        .filter((button) => button.isVisible)
        .map(({ isVisible, ...button }) => button),
    [canEditProject, handleEdit, handleTasks]
  );

  return (
    <>
      <AppCard
        title={generateProjectLabel(project.name, project.code)}
        statusInfo={project.ongoing}
        details={[
          generateProjectDetails('Client', project.client.name),
          generateProjectDetails(
            RolesNames.PROJECT_MANAGER,
            project.projectOwner.name
          ),
          generateProjectDetails(
            RolesNames.SALES_MANAGER,
            project.salesManager.name
          ),
          ...(project.client.salesPerson 
            ? [generateProjectDetails('Sales', project.client.salesPerson.name)]
            : []
          ),
        ]}
        buttons={cardActionButtons}
      />

      {/* <AppConfirmationDelete
        isOpen={isOpenDeleteDialog}
        message={`Delete Project ${project.name}?`}
        onClose={handleCloseDeleteDialog}
        onConfirm={handleConfirmDeleteProject}
      /> */}

      <AppConfirmationSuccessful
        isOpen={isOpenConfirmationDialog}
        message="Project Deleted!"
        onClose={handleCloseConfirmationDialog}
      />
    </>
  );
}
